/** Janela em que a cota de sessões se renova (calendário local do prestador). */
export enum QUOTA_PERIOD {
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}
